/*
 * View for the historic response in the history modal
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponseHistoryModal/topicResponseHistoryViewer/template/topicResponseHistoryViewerTemplate.html",
], function (Marionette, Messenger, TopicResponseHistoryViewerTemplate) {
  var TopicResponseHistoryViewerView = {};

  TopicResponseHistoryViewerView.topicResponseHistoryViewerView = Marionette.ItemView.extend({
    template: TopicResponseHistoryViewerTemplate,
    disableRollbackButton: function () {
      this.$el.find("#rollbackButton").prop("disabled", true);
    },
    hideRollbackButton: function () {
      this.$el.find("#rollbackButton").css("display", "none");
    },
    triggers: {
      "click #rollbackButton": "rollback",
    },
    templateHelpers: {
      getDateTimeDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateTime:long", date);
      },
    },
  });

  return TopicResponseHistoryViewerView;
});
